// extracted by mini-css-extract-plugin
export default {"totals":"yV4C7","total":"FoGrP","quote-total":"fZFAu","quoteTotal":"fZFAu","total-value":"YpPZ5","totalValue":"YpPZ5"};